/** @jsxImportSource @emotion/react */
import * as React from 'react';
 import { css} from '@emotion/react'
 import { Form, Input, Radio, Select, Space, Table} from 'antd';
import { Pagination } from 'antd';
import Button from '@mui/material/Button';
import { useState } from 'react';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { ButtonBase, IconButton } from '@mui/material';

import axios from '../apiClient';
import { useEffect } from 'react';
import { useRef } from 'react';
import Loader from '../loader';
import Alert from '../alert';
import { useLang } from '../../context';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'white',
  borderRadius: "1rem",
  boxShadow: 24,
  p: 4,
};

export default function PointAdjustment() {
  const [page,setPage] = useState(1);
  const [agents,setAgents] = useState([]);
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [totalAgents, setTotalAgents] = useState();
  const [openModel, setOpenModel] = React.useState(false);
  const [radioValue, setRadioValue] = React.useState("add");
  const {text} = useLang();
  
  const [modalLoading,setModalLoading] = useState(false)
  const [selectedMemberId,setSelectedMemberId] = useState()
  const [searchName,setSearchName] = useState('');
  const [paymentMethods,setPaymentMethods] = useState([]);
  const mounted = useRef(false)
  const submittingRef = useRef(false)

  async function fetchData() {
    setLoading(true)
    let data = await axios.get(`/member/getAllMembers?current=${page}&pageSize=10`)

    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setAgents([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setAgents(data.data.agents)
    setTotalAgents(data.data.pagination.total)
    setLoading(false) 
  }

  useEffect(()=>{
    if(mounted){
      getPaymentMethod()
      if(searchName != ''){
        handleSearch(searchName,page)
        return;
      }
      fetchData()
    }
  },[page])

  useEffect(()=>{
    if(mounted.current) setPage(1)
  },[searchName])

  useEffect(()=>{
    mounted.current = true
    fetchData()
  },[])

  const handleModelClose = () => setOpenModel(false);
  const onFinish = async (values) => {
 
    if (submittingRef.current) return
    submittingRef.current = true
    let amount;
    const {points,action,payment,note} = values
    if(action == 'add') amount = points 
    if(action == 'reduce') amount = -points 
    setModalLoading(true)
    // const reason = action == 'add' ? 'Deposit' :  'Withdraw';
    let params = {holderId: selectedMemberId,amount,paymentMethod: payment,note: note || ""};
    try{
      let data = await axios.post(`/wallet/setTransferAmount`, params)
      let msgObj = { code: data.code, msg: data.message }
      if(data.code == 200 && action == 'add') msgObj.msg =  "Successfully deposited the member wallet"
      if(data.code == 200 && action == 'reduce') msgObj.msg =  "Successfully withdraw the member wallet"
      setErrorMsg(msgObj)
      setOpenAlert(true)
      if(data.code == 200){
        setOpenModel(false)
        handleSearch(searchName,page)
      }
    } finally {
      setModalLoading(false)
      submittingRef.current = false
    }
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };
  const columns = [
    {
      title: text['Username'],
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: text['Full Name'],
      dataIndex: 'full_name',
      key: 'full_name',
    },
    {
      title: text['Phone No.'],
      key: 'phone_number',
      dataIndex: 'phone_number',
    },
    {
      title: text['Units'],
      key: 'amount',
      dataIndex: 'amount',
      render : (amount) => Number(amount).toLocaleString()
    },
    {
      title: text['Action'],
      render: ({id: holderId}) => {
        const managePointsColor = "#0E8388"
  
        return (
        <Space size="middle">
          <Button disableRipple disableFocusRipple onClick={()=> {
            setOpenModel(true);
            setSelectedMemberId(holderId)
          }} css={css`color: black;border-color: ${managePointsColor};:hover{border-color: ${managePointsColor};}`} color='success' variant="outlined" startIcon={<MonetizationOnRoundedIcon css={css`color: ${managePointsColor};`}/> }>
            Manage Units
         </Button>
        </Space>
      )},
    },
  ];
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
  const handleSearch = async (name,page) =>{
    setLoading(true)
    setSearchName(name)
    let data = await axios.get(`/member/getMemberByName?uname=${name}&current=${page}&pageSize=10`)
    setLoading(false)
    if (data.code != 200) {
        if(data.code == 404){
          setAgents([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        return
    }
    setAgents(data.data.members)
    setTotalAgents(data.data.pagination.total)
    }
  const handlePageChange = (page) => {
    setPage(page)
  }
  const getPaymentMethod = async () => {
    const res = await axios.get(`/member/getPaymentChannelList`);
    if(res.code == 200){
      const arr = res?.data?.map(v=> {
        return {value: v?.channel_name,label: v?.display_name};
      })
      setPaymentMethods(arr);
    }
  }
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModel}
        onClose={handleModelClose}
        keepMounted
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            transitionDuration: 150,
          },
        }}
      >
        <Fade in={openModel} timeout={150}>
          <Box sx={style} css={css`padding: 1.4rem 32px;`}>
            <div css={css`display: flex;justify-content: center;align-items: center;`}>
             <IconButton css={css`background-color: #ede7f6;`}>
               <MonetizationOnRoundedIcon css={css`color: #5e35b1;`}/>
             </IconButton>
            </div>
            <div css={css`font-family: cursive;margin-top: 1.4rem;display: flex;justify-content: center;align-items: center;font-size: 1.125rem;`}>
              Manage Units
            </div>
            <Form
              name="basic"
              className="modal-points"
              style={{
                marginTop: "2rem",
                fontFamily: "inherit",
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="Action"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="action"
                style={{ padding: "0 0.4rem", color: "white" }}
                rules={[
                  {
                    required: true,
                    message: `Please choose one action!`,
                  },
                ]}
                initialValue={"add"}
              >
              <Radio.Group onChange={(v)=>setRadioValue(v)} value={radioValue} defaultValue="add">
                <Radio defaultChecked value="add" css={css`margin-left: 1rem;`}>
                  {text['Add']} (+)
                </Radio>
                <Radio  value="reduce">
                  {text['Reduce']} (-)
                </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="Units"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="points"
                style={{ padding: "0 0.4rem", color: "white" }}
                rules={[
                  {
                    required: true,
                    message: `Please input units!`,
                  },
                ]}
              >
                <Input 
                onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
                type="number"  size="large" css={css`margin-left: 2rem;`} min={0}/>
              </Form.Item>
              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="payment"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="payment"
                style={{ padding: "0 0.4rem", color: "white" }}
                rules={[
                  {
                    required: true,
                    message: `Please input payment method!`,
                  },
                ]}
              >
                <Select
                  css={css`margin-left: 2rem;`}
                  dropdownStyle={{zIndex: 2000}}
                  size='large'
                  options={paymentMethods}
                />
              </Form.Item>

              <Form.Item
                css={css`
                      flex-basis: 50%;
                      .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                    `}
                label="note"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 17 }}
                name="note"
                style={{ padding: "0 0.4rem", color: "white" }}
                rules={[
                  {
                    required: true,
                    message: `Please input note!`,
                  },
                ]}
              >
                <Input  size="large" css={css`margin-left: 2rem;`}/>
              </Form.Item>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  padding: "0.6rem 0 0 0",
                  marginTop: "1rem",
                }}
              >
                <ButtonBase
                  component="button"
                  onClick={()=> setOpenModel(false)}
                  style={{
                    color: "black",
                    display: "flex",
                    backgroundColor: "#D27685",
                    padding: "0.6rem 1.8rem",
                    borderRadius: "2rem",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: "1rem"
                  }}
                >
                  <h4 style={{ textAlign: "center", margin: 0 }}>Cancel</h4>
                </ButtonBase>
                <ButtonBase
                  type="submit"
                  component="button"
                  style={{
                    color: "black",
                    display: "flex",
                    backgroundColor: "#408E91",
                    padding: "0.6rem 1.8rem",
                    borderRadius: "2rem",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {modalLoading? <Loader btn creatUser/> : <h4 style={{ textAlign: "center", margin: 0 }}>Submit</h4>}
                </ButtonBase>
              
              </div>
            </Form>
          </Box>
        </Fade>
      </Modal>
    <div>
      <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <div css={css`display: flex;justify-content: space-between;`}>
        <input placeholder={`${text['Search']}...'`} css={css`padding: 0.6rem 0.6rem;border-radius: 0.6rem;border: 1px solid grey;outline: none;&:focus {border-color: #5e35b1;}`} onChange={(e)=>handleSearch(e.currentTarget.value,page)}/>
      </div>
      <Table loading={loading} scroll={{x: 'max-content'}} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={agents} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalAgents} pageSize={10} showSizeChanger={false} onChange={(page)=> handlePageChange(page)}/>
    </div>
  </div>
  )
}
